/** ROLES */
const ROLE_ADMIN = 'admin'
const ROLE_OWNER = 'owner'
const ROLE_JANITOR = 'janitor'
const ROLE_PRESIDENT = 'president'

/** PROPERTY TYPES */
const PROPERTY_HOME = 'home'
const PROPERTY_PARKING = 'parking'
const PROPERTY_COMMERCIAL = 'commercial'

/** VOTES */
const VOTE_FOR = 'for'
const VOTE_AGAINST = 'against'
const VOTE_ABSTAIN = 'abstain'
const VOTE_NONE = 'none'

/** TICKETS STATUSES */
const STATUS_NOTIFIED = 'notified'
const STATUS_WORKING = 'working'
const STATUS_RESOLVED = 'resolved'

const FRIENDLY_STATUS = {}
FRIENDLY_STATUS[STATUS_NOTIFIED] = 'Notificado'
FRIENDLY_STATUS[STATUS_WORKING] = 'Atendido'
FRIENDLY_STATUS[STATUS_RESOLVED] = 'Resuelto'

/** ANNOUNCE TYPES */
const ANN_TYPE_ANNOUNCE = 'announce'
const ANN_TYPE_POLL = 'poll'

/** PERIDICITY OPTIONS */
const PERIOD_NONE = 'none'
const PERIOD_DAILY = 'daily'
const PERIOD_WEEKLY = 'weekly'
const PERIOD_MONTHLY = 'monthly'

const PERIOD_ADDITION_FACTOR = {}
PERIOD_ADDITION_FACTOR[PERIOD_DAILY] = 'd'
PERIOD_ADDITION_FACTOR[PERIOD_WEEKLY] = 'w'
PERIOD_ADDITION_FACTOR[PERIOD_MONTHLY] = 'M'

const FRIENDLY_PERIODICITY = {}
FRIENDLY_PERIODICITY[PERIOD_NONE] = 'No se repite'
FRIENDLY_PERIODICITY[PERIOD_DAILY] = 'Todos los días'
FRIENDLY_PERIODICITY[PERIOD_WEEKLY] = 'Todas las semanas'
FRIENDLY_PERIODICITY[PERIOD_MONTHLY] = 'Todos los meses'

/** MAX POLL CHOICES */
const LIMITS_MAX_POLL_CHOICES = 6

/** MAX ATTACHMENTS PER TICKET */
const LIMITS_MAX_ATTACHMENTS_TICKET = 5

/** Default batch size of queries (announcements, meetings, deliveries, etc) */
const BATCH_SIZE = 100

/** FILE UPLOADING */
const ALLOWED_FILE_TYPES = [
    'text/plain',
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]
const MAX_FILE_SIZE = 5 * 1024 * 1024 // (5MB)

/** Avatar color map */
const AVATAR_COLORS = [
    '#033023',
    '#B8860B',
    '#C04000',
    '#6B8E23',
    '#CD853F',
    '#C0C000',
    '#228B22',
    '#D2691E',
    '#808000',
    '#20B2AA',
    '#F4A460',
    '#00C000',
    '#8FBC8B',
    '#B22222',
    '#843A05',
    '#C00000',
]

export {
    ROLE_ADMIN,
    ROLE_OWNER,
    ROLE_JANITOR,
    ROLE_PRESIDENT,
    PROPERTY_HOME,
    PROPERTY_PARKING,
    PROPERTY_COMMERCIAL,
    VOTE_FOR,
    VOTE_AGAINST,
    VOTE_ABSTAIN,
    VOTE_NONE,
    STATUS_NOTIFIED,
    STATUS_WORKING,
    STATUS_RESOLVED,
    FRIENDLY_STATUS,
    PERIOD_NONE,
    PERIOD_DAILY,
    PERIOD_WEEKLY,
    PERIOD_MONTHLY,
    PERIOD_ADDITION_FACTOR,
    FRIENDLY_PERIODICITY,
    ANN_TYPE_ANNOUNCE,
    ANN_TYPE_POLL,
    LIMITS_MAX_POLL_CHOICES,
    LIMITS_MAX_ATTACHMENTS_TICKET,
    BATCH_SIZE,
    ALLOWED_FILE_TYPES,
    MAX_FILE_SIZE,
    AVATAR_COLORS,
}
